import React from 'react'
import PropTypes from 'prop-types'
import ImmutablePropTypes from 'react-immutable-proptypes'
import { Field, FieldArray } from 'redux-form/immutable'
import get from 'lodash/get'
import i18next from 'i18next'

import TextArea from 'app/components/TextArea'
import Select from 'app/components/Select'
import CheckBox from 'app/components/CheckBox'
import Button from 'app/components/ButtonDefault'
import SelectArray from './SelectArray'

import './styles.scss'
import cn from 'classnames'

const bc = 'manage-protracks-form'

const validateProTrackLevel = value =>
  value === '0' ? `${i18next.t('Please select')} ${i18next.t('ProTrackLevel')}` : undefined

const ManageProTracksForm = ({
  handleSubmit,
  teams,
  reset,
  pristine,
  proTrackLevels,
  isWaitingProTrackLevels,
  isEntireOrg,
  isTeamsEnter,
  isEmailsEnter,
  t,
  i18n: { language },
  isSwitchProTrackLevelForm,
}) => {
  return (
    <div className={`${bc}__wrapper`}>
      <span className={`${bc}__title`}>
        {isSwitchProTrackLevelForm
          ? t(
              'admin:Select the users you would like to move and the track you would like to switch them to on their next scheduled day of MicroActions'
            )
          : t('admin:Select the users whom you would like to stop ProHabits for')}
      </span>
      <form onSubmit={handleSubmit}>
        <div className={`${bc}__form`}>
          <div className={`${bc}__left`}>
            <div className={`${bc}__wrapper-input-emails`}>
              <Field
                name="emails"
                component={TextArea}
                placeholder={t('Email Address')}
                needCharactersLabel={false}
                style={{ width: '350px' }}
                className={`${bc}__input-emails`}
                disabled={isEntireOrg}
                label={t('admin:List of individual emails')}
              />
              <span className={`${bc}__tip`}>
                {t('common:Format')}: {t('admin:one email per line')}
              </span>
            </div>
            <div className={cn(`${bc}__and-or`, { [`${bc}__and-or__${language}`]: language })} />
            <FieldArray name="teams" component={SelectArray} options={teams} disabled={isEntireOrg} />
          </div>
          <div className={cn(`${bc}__or`, { [`${bc}__or__${language}`]: language })} />
          <div className={`${bc}__right`}>
            <div>
              <div className={`${bc}__label`}>{t('admin:Entire Company')}</div>
              <Field
                name="entireOrg"
                component={CheckBox}
                label={t('admin:Entire Organization')}
                disabled={isEmailsEnter || isTeamsEnter}
              />
            </div>
            {isSwitchProTrackLevelForm &&
              (isWaitingProTrackLevels ? (
                <div
                  className="loader__row"
                  style={{
                    height: 30,
                    width: 250,
                    display: 'inline-block',
                    marginRight: 25,
                  }}
                />
              ) : (
                <Field
                  name="proTrackLevelId"
                  component={Select}
                  options={proTrackLevels}
                  getValue={option => option.id || '0'}
                  getLabel={option => (option.id ? `${get(option, 'proTrack.name')} – ${option.name}` : option)}
                  getKey={option => (option.id ? `${option.name}_${option.id}` : option)}
                  styleSelect={{ width: '300px' }}
                  validate={[validateProTrackLevel]}
                  label={t('admin:Next ProTrack')}
                  isRowView={false}
                  labelClassName={`${bc}__label`}
                />
              ))}
          </div>
        </div>
        <div className={`${bc}__buttons`}>
          <Button xs primary type="submit" disabled={pristine || (!isEmailsEnter && !isEntireOrg && !isTeamsEnter)}>
            {isSwitchProTrackLevelForm ? t('user:Switch ProTrack') : t('admin:Stop ProTracks')}
          </Button>
        </div>
      </form>
    </div>
  )
}

ManageProTracksForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  teams: PropTypes.arrayOf(PropTypes.string).isRequired,
  reset: PropTypes.func.isRequired,
  pristine: PropTypes.bool.isRequired,
  proTrackLevels: ImmutablePropTypes.listOf(
    PropTypes.oneOfType([
      PropTypes.shape({
        id: PropTypes.number.isRequired,
        name: PropTypes.string.isRequired,
        proTrack: PropTypes.shape({
          name: PropTypes.string.isRequired,
        }).isRequired,
      }),
      PropTypes.string,
    ]).isRequired
  ).isRequired,
  isWaitingProTrackLevels: PropTypes.bool.isRequired,
  selectedOrgId: PropTypes.number.isRequired,
  isEntireOrg: PropTypes.bool.isRequired,
  isEmailsEnter: PropTypes.bool.isRequired,
  isTeamsEnter: PropTypes.bool.isRequired,
  isSwitchProTrackLevelForm: PropTypes.bool.isRequired,
}

export default ManageProTracksForm
